import React, { useState } from 'react'
import "./About.css"
import about from "../../Images/about_logo.svg"
import { Row, Col, Nav, Carousel } from "react-bootstrap"
import bear1 from "../../Images/bear1.png"
import bear2 from "../../Images/bear2.png"
import bear3 from "../../Images/bear3.png"
import war from "../../Images/war.jpg"
import aboutt from "../../Images/aboutt.png"
import carousel1 from "../../Images/carousel1.jpg"
import carousel2 from "../../Images/carousel2.jpg"
import carousel3 from "../../Images/carousel3.jpg"
import carousel4 from "../../Images/carousel4.jpg"
import carousel5 from "../../Images/carousel5.jpg"
import carousel6 from "../../Images/carousel6.jpg"
import carousel7 from "../../Images/carousel7.jpg"
// import { Carousel } from "antd"

function About() {
    const [data, setData] = useState([{ text: "Randomly Generated", img: bear1 }, { text: "Subrrrreme Aesthetic", img: bear2 }, { text: "10k Solarbears", img: bear3 }])
    return (
        <>

            <div id="about">

                <div className="container about" >
                    <div className="about_section">
                        <div>
                            {/* <h2 className="about_force">What is the 0n1 force?</h2>
                    <br /> */}

                            <h4 className="about_on">10,000 furry Solarbears have been displaced from their melting homes caused by increased transactions and gas emissions.
                            </h4><br />

                            <h3 className="about_on">After a long migration they discovered the land of Solana, an ecosystem filled with fresh snow
                                and ice cold mountains to roam in. Come join the Solarbears as they explore this new landscape!</h3>
                        </div>
                        <div className="caross">
                            <img src={carousel1} className="caros" />

                            <Nav.Link href="https://discord.gg/XYRkqRg9" target="./blank" className="linkeds">


                                <div className="story_discords">
                                    <p className="story_joins">Join discord</p>
                                </div></Nav.Link>

                        </div>
                    </div>

                    {/* <div className="logo_div">
                    <img src={about} className="about_logo" />
                </div> */}
                    {/* <br /> */}

                    {/* text section */}

                    {/* <div className="about_section">
                    <div>
                        <h2 className="about_force">What is the 0n1 force?</h2>
                    <br />

                        <h4 className="about_on">10,000 furry Solarbears have been displaced from their melting homes caused by increased transactions and gas emissions.
                        </h4><br />

                        <h3 className="about_on">After a long migration they discovered the land of Solana, an ecosystem filled with fresh snow
                            and ice cold mountains to roam in. Come join the Solarbears as they explore this new landscape!</h3>
                    </div>
                    <div className="caros">
                        <img src={carousel1} className="caros" />
                    </div>
                </div> */}

                    {/* open sea link */}
                    <div>
                        <Nav.Link href="https://opensea.io/" target="./blank" className="link"><div className="about_sea">
                            <p className="about_opensea">OpenSea</p>
                        </div></Nav.Link></div>
                    <br /><br />


                    {/* cards */}

                    <div >
                        <Row className="card_row" >
                            {data.map((dat) => (<Col className="col_card" xl={4} lg={4} md={12} sm={12} xs={12}>

                                <img className="about_one" src={dat.img} />
                                <p className="character">{dat.text}</p>

                            </Col>
                            ))}

                        </Row>

                    </div>

                    <div className="homes_im">
                        <img src={war} className="hom_img" />
                    </div><br />


                    {/* the story */}

                    <div className="story_div">
                        {/* <h1 className="story_head">\\ THE STORY</h1>
                        <h4 className="story_title">LIFE IN THE ETHEREAL ENCLAVE WAS PEACEFUL AND PROSPEROUS. RULE UNDER THE EMPEROR GRANTED ETERNAL LIFE; INFINITE LEISURE FOR MUSIC, ARTS, AND POETRY.</h4>
                        <h4 className="story_title">FOR MANY THIS WAS BLISS, BUT WHEN THE EMPEROR SUDDENLY DIED WITHOUT AN HEIR, EVERYTHING COLLAPSED.</h4>
                        <h4 className="story_title">WHAT WAS ONCE EVERLASTING HAS NOW BEEN CONDENSED TO A MERE 7,777 HOURS.</h4>
                        <h4 className="story_title">NOW, GATHERING MEANS FOR SURVIVAL AS SOCIETY CRUMBLES, THE 0N1 FACE THEIR GREATEST ENEMIES: THEMSELVES.</h4>
                        <br /> */}
                        <h1 className="story_head">LORE</h1>
                        <h4 className="story_title">SINCE THE DAWN OF TIME, 10,000 FLUFFY SOLARBEARS HAVE BEEN FIGHTING THE RIGZ, A RACE OF MACHINES THAT CONSUMES
                            AND FEEDS FROM THE ATMOSPHERIC GAS OF PLANETS TO PROCESS TRANSACTIONS FROM THEIR OVERLORDS. FOR MILLENIA THE SOLARBEARS HAD MANAGED TO
                            KEEP THE RIGZ AT BAY. BUT ONE DAY, TRANSACTION DEMAND WENT THROUGH THE ROOF AND THEIR HOMELAND GOT TOO HOT. THE LAST DOCUMENTED PIECE OF
                            HISTORY WAS A HEAT SIGNATURE OF OVER 9,000.</h4>
                        <h4 className="story_title">AFTER THEIR HABITAT MELTED, THE SOLARBEARS WERE FORCED TO ADAPT. THEY EVOLVED TO
                            THEIR CURRENT MAJESTIC FORM AND SET OFF TO FIND A NEW HOME. </h4>
                        <h4 className="story_title">THE SOLARBEARS JUST ARRIVED TO THE SOLANA ECOSYSTEM, BUT RUMOR HAS IT, THE RIGZ HAVE BEEN FOLLOWING THEM
                            AND THEIR HUNGER CAN’T BE SATIATED. THEIR JOURNEY IS JUST BEGINNING AND THEY ARE READY RRRUMBLE.</h4>

                        <br />
                        <div >


                            <Carousel style={{ height: '500px' }}>
                                <Carousel.Item className="caro_one">
                                    <img
                                        className="d-block w-100 caro_im" style={{ height: '100%' }}
                                        src={carousel1}
                                        alt="First slide"
                                    />
                                </Carousel.Item>
                                <Carousel.Item className="caro_one">
                                    <img
                                        className="d-block w-100 caro_im" style={{ height: '100%' }}
                                        src={carousel2}
                                        alt="Second slide"
                                    />

                                </Carousel.Item>
                                <Carousel.Item className="caro_one" >
                                    <img
                                        className="d-block w-100 caro_im" style={{ height: '100%' }}
                                        src={carousel3}
                                        alt="Third slide"
                                    />
                                </Carousel.Item>
                                <Carousel.Item className="caro_one" >
                                    <img
                                        className="d-block w-100 caro_im" style={{ height: '100%' }}
                                        src={carousel4}
                                        alt="First slide"
                                    />
                                </Carousel.Item>
                                <Carousel.Item className="caro_one" >
                                    <img
                                        className="d-block w-100 caro_im" style={{ height: '100%' }}
                                        src={carousel5}
                                        alt="Second slide"
                                    />

                                </Carousel.Item>
                                <Carousel.Item className="caro_one">
                                    <img
                                        className="d-block w-100 caro_im" style={{ height: '100%' }}
                                        src={carousel6}
                                        alt="Third slide"
                                    />
                                </Carousel.Item>
                                <Carousel.Item className="caro_one" >
                                    <img
                                        className="d-block w-100 caro_im" style={{ height: '100%' }}
                                        src={carousel7}
                                        alt="Third slide"
                                    />
                                </Carousel.Item>
                            </Carousel>

                        </div>
                        <Nav.Link href="https://discord.gg/XYRkqRg9" target="./blank" className="linked">


                            <div className="story_discord">
                                <p className="story_join">Join discord</p>
                            </div></Nav.Link>
                    </div>


                </div><br />

                <div className="last_div">
                    <img className="last_img" src={aboutt} />
                </div>
            </div>

        </>
    )
}

export default About
